export const intro = () =>
    `<div class="lightBlue">${document.getElementById('intro').innerHTML}</div>`;
